import { OrderNotesTable } from '@/components/features/order-note'

export const NoteList = () => {
  return <OrderNotesTable />
}
